// This file was generated by AI from DatePickerMonthView and then manually adapted for quarter selection.
import {DatePicker as ArkDatePicker} from '@ark-ui/react/date-picker'
import {DatePickerViewControl} from '../view_control'
import './index.less'

const NUM_OF_QUARTERS_IN_A_YEAR = 4
const NUM_OF_MONTH_IN_A_QUARTER = 3

export const DatePickerQuarterView = () => {
	return (
		<ArkDatePicker.View view="month">
			<ArkDatePicker.Context>
				{datePicker => {
					const months = datePicker.getMonthsGrid({columns: NUM_OF_QUARTERS_IN_A_YEAR, format: 'short'}).flat()
					const quarters = Array.from({length: NUM_OF_QUARTERS_IN_A_YEAR}, (_, quarterIndex) => {
						const quarterMonths = months.slice(quarterIndex * NUM_OF_MONTH_IN_A_QUARTER, (quarterIndex + 1) * NUM_OF_MONTH_IN_A_QUARTER)

						return {disabled: quarterMonths.some(month => month.disabled), label: `Q${quarterIndex + 1}`, value: quarterMonths[0].value}
					})

					return (
						<>
							<DatePickerViewControl />
							<ArkDatePicker.Table className="date-picker-quarter-view" columns={NUM_OF_QUARTERS_IN_A_YEAR}>
								<ArkDatePicker.TableBody>
									<ArkDatePicker.TableRow>
										{quarters.map(quarter => (
											<ArkDatePicker.TableCell key={quarter.label} value={quarter.value} disabled={quarter.disabled}>
												<ArkDatePicker.TableCellTrigger>{quarter.label}</ArkDatePicker.TableCellTrigger>
											</ArkDatePicker.TableCell>
										))}
									</ArkDatePicker.TableRow>
								</ArkDatePicker.TableBody>
							</ArkDatePicker.Table>
						</>
					)
				}}
			</ArkDatePicker.Context>
		</ArkDatePicker.View>
	)
}
